import {Tag} from 'antd';
import {ReactElement} from 'react';

import {Text} from '../../../../../../../../component/text/text';
import {
    formatResponsibleUserName,
    ResponsibleUserType,
} from '../../../../../../../../service/reviews/reviews-responsible-users';
import {classNames} from '../../../../../../../../util/css';
import * as tagListStyles from '../../../../../tag-list/tag-list.scss';

import * as styles from './history-modal.scss';

type PropsType = {
    user: ResponsibleUserType | null;
};

export function ResponsibleUserBadge(props: PropsType): ReactElement {
    const {user} = props;
    const name = formatResponsibleUserName(user);

    return (
        <Tag
            className={classNames(
                styles.HistoryModal_responsibleUserBadge,
                tagListStyles.TagList_itemAutotag,
                tagListStyles.TagList_responsibleUser
            )}
        >
            {name ? (
                <Text bolder lighter small>
                    {name}
                </Text>
            ) : (
                <Text bolder lighter small stringKey="REVIEWS__RESPONSIBLE_USER__NOT_SELECTED" />
            )}
        </Tag>
    );
}
